import { useEffect, useState } from "react";
import { inventoryActions } from "redux/Ldb/actions";
import { useAppDispatch, useAppSelector } from "../storeHooks";
import useInfiniteScroll from "../useInfinteScroll";
import { debounce, uniqBy } from "lodash";

const useGetUOM = () => {
    const dispatch = useAppDispatch();

    const [uoms, setUoms] = useState<{ [key: string]: any }[]>([]);
    const [pagination, setPagination] = useState<{ currentPage: string; noOfPages: string }>({
        currentPage: "1",
        noOfPages: "",
    });
    const {
        fetchingCustomUOM,
        fetchedCustomUOMSuccess,
        fetchedCustomUOMFailure,
        createdCustomUOMSuccess,
    } = useAppSelector((state) => state.inventory);

    // const { updatedLimit, isLoadingMore, setLoadMore, updatedPage, setUpdatedPage } =
    //     useInfiniteScroll(
    //         { current: pagination.currentPage, number_of_pages: pagination.noOfPages },
    //         10
    //     );

    useEffect(() => {
        dispatch(inventoryActions.getCustomUOM());

        return () => {
            dispatch(inventoryActions.resetGetCustomUOMSuccess());
        };
    }, [dispatch, createdCustomUOMSuccess]);

    useEffect(() => {
        if (Boolean(fetchedCustomUOMSuccess)) {
            setUoms((prev) => uniqBy([...fetchedCustomUOMSuccess?.units], "_id"));
            // setPagination({
            //     currentPage: fetchedCustomUOMSuccess.pagination?.current,
            //     noOfPages: fetchedCustomUOMSuccess.pagination?.number_of_pages,
            // });
            // setLoadMore(false);
        }
    }, [fetchedCustomUOMSuccess]);

    return {
        isFetching: fetchingCustomUOM,
        error: fetchedCustomUOMFailure,
        data: uoms,
        setUoms,
        pagination,
        setPagination,
        // isLoadingMore,
        // setUpdatedPage,
        // updatedPage,
    };
};

export default useGetUOM;
